export const loadMoreFoldersAction = "tJc";
export default {loadMoreFoldersAction};